import clsx from "clsx"
import { Img } from "src/components/unstyled/Img"

export type LogoData = {
  name: string
  icon: string
  background?: string
}

export type LogosProps = {
  logos: LogoData[]
  size: "sm" | "md" | "lg"
}

export const Logos = ({ logos: paymentMethods, size }: LogosProps) => {
  if (!paymentMethods?.length) {
    return null
  }

  return (
    <ul className="flex flex-wrap items-center justify-center gap-2">
      {paymentMethods.map((method, index) => (
        <li
          key={index}
          title={method.name}
          className={clsx("aspect-video rounded-lg border", {
            "w-16 px-1 py-0.5": size === "sm",
            "w-20 px-2 py-1": size === "md",
            "w-24 px-4 py-2": size === "lg",
            "bg-white/75": !method.background,
          })}
          style={method.background ? { backgroundColor: method.background } : undefined}
        >
          <Img src={method.icon} alt={method.name} className="size-full object-contain" />
        </li>
      ))}
    </ul>
  )
}
